import {
  Center,
  Empty,
  EmptyHeadline,
  EmptyDescription,
  EmptyDrawerIcon,
  FilterIcon,
  Button,
  Tooltip,
  ReqsReviewFeatureIcon,
  Spinner,
} from '@frontend/legacy-components';

interface RulesEmptyStateProps {
  isFiltered: boolean;
  isLoadingRules: boolean;
  isReadOnlyPermission: boolean;
  onCreateRule: () => void;
}

export const RulesEmptyState = ({
  isFiltered,
  isReadOnlyPermission,
  onCreateRule,
  isLoadingRules,
}: RulesEmptyStateProps) => {
  if (isLoadingRules) {
    return (
      <Center py={6}>
        <Spinner size="lg" />
      </Center>
    );
  }

  if (isFiltered) {
    return (
      <Empty py={6}>
        <FilterIcon />
        <EmptyHeadline>No rules match your search</EmptyHeadline>
        <EmptyDescription>
          Try adjusting your search term to find more rules.
        </EmptyDescription>
      </Empty>
    );
  }

  return (
    <Empty py={6} size="lg">
      <EmptyDrawerIcon as={ReqsReviewFeatureIcon} />
      <EmptyHeadline>No rules</EmptyHeadline>
      <EmptyDescription>
        Create rules to automate certain activities based on quote and file
        content.
      </EmptyDescription>
      {isReadOnlyPermission ? (
        <Tooltip label="You don't have permission to create new rules">
          <Button size="md" mt={3} isDisabled={true}>
            Create Your First Rule
          </Button>
        </Tooltip>
      ) : (
        <Button size="md" mt={3} onClick={onCreateRule}>
          Create rule
        </Button>
      )}
    </Empty>
  );
};
